import { FC, PropsWithChildren } from 'react'
import {
  Inspector,
  IconFileBend,
  GreyGrey70
} from '@sequencehq/core-components'

export const AttachmentsInspectorItem: FC<PropsWithChildren> = ({
  children
}) => {
  return (
    <Inspector.IconItem
      data-testid="attachments.inspector.item"
      tooltip="Attachments"
      content={children}
      icon={<IconFileBend color={GreyGrey70} />}
    />
  )
}
